// extracted by mini-css-extract-plugin
export default {"requirements":"styles_requirements__xgLyO","warning":"styles_warning__2Bf1n"};